{
  "version": "buyer-side-diligence-checklist.v2",
  "source": "Buyer-side diligence checklist v2 (Oct 14, 2026); v2 adds plain-language text, owners, due dates, capture fields, jurisdiction labels and buyer-profile tokens (Oct 20, 2026)",
  "phases": [
    "pre_offer",
    "pre_closing",
    "post_closing"
  ],
  "statuses": [
    "Complete",
    "Partial",
    "Missing",
    "N/A"
  ],
  "note": "Seller decline curves are the seller forecast case, in whatever file the seller sent. Reserve report follows the source wording: if available, so it is not required. Rows marked operatedOnly are N/A on a non-operated purchase.",
  "items": [
    {
      "id": "PO-F-01",
      "phase": "pre_offer",
      "category": "financial",
      "item": "Last two years Income and Expense Reports (LOEs)",
      "method": "auto",
      "requiredForPhase": true,
      "rule": {
        "type": "auto",
        "check": "PO-F-01",
        "text": "deal-package cashflow.losMonths: months>=24 Complete, 12-23 Partial, <12 Missing; loe present"
      },
      "whatSatisfies": "Lease operating statements with income and expense for the last 24 months, ending at the effective date.",
      "kind": "request",
      "owner": "Accounting"
    },
    {
      "id": "PO-F-02",
      "phase": "pre_offer",
      "category": "financial",
      "item": "Two years of lease operating reports by well/lease",
      "method": "auto",
      "requiredForPhase": true,
      "rule": {
        "type": "auto",
        "check": "PO-F-02",
        "text": "per-well LOS rows (well/lease key) >=24 mo; else Data Room doc type los_by_well (JADE/LOS detail)",
        "docTypes": [
          "los_by_well"
        ]
      },
      "whatSatisfies": "Operating reports broken out by well or lease for the same 24 months.",
      "kind": "request",
      "owner": "Accounting"
    },
    {
      "id": "PO-F-03",
      "phase": "pre_offer",
      "category": "financial",
      "item": "Last two years of JIBs",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-F-03",
        "text": "Data Room doc type jib (JIB|joint interest bill)",
        "docTypes": [
          "jib"
        ]
      },
      "whatSatisfies": "Joint interest billings sent or received for the last 24 months.",
      "kind": "request",
      "owner": "Accounting"
    },
    {
      "id": "PO-F-04",
      "phase": "pre_offer",
      "category": "financial",
      "item": "Name of all first purchasers",
      "method": "auto",
      "requiredForPhase": true,
      "rule": {
        "type": "auto",
        "check": "PO-F-04",
        "text": "diligence.midstreamAssignability.contracts role~purchaser, or purchaser contract doc",
        "docTypes": [
          "purchase_contract"
        ]
      },
      "whatSatisfies": "The crude and gas purchaser for each lease, by name.",
      "kind": "request",
      "owner": "Accounting",
      "feeds": [
        "PO-F-08",
        "PS-O-02"
      ]
    },
    {
      "id": "PO-F-05",
      "phase": "pre_offer",
      "category": "financial",
      "item": "Backoffice support software",
      "method": "manual",
      "requiredForPhase": false,
      "rule": {
        "type": "manual",
        "check": "PO-F-05",
        "text": "Attestation (text)"
      },
      "whatSatisfies": "The seller's accounting and land system, for example PakEnergy, WolfePak or Quorum.",
      "kind": "request",
      "owner": "Accounting",
      "fields": [
        {
          "key": "software",
          "label": "System",
          "type": "text"
        }
      ]
    },
    {
      "id": "PO-F-06",
      "phase": "pre_offer",
      "category": "financial",
      "item": "Number of Working Interest & Royalty owners",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-F-06",
        "text": "doc type owner_list|division_order|pay_deck; count captured on override",
        "docTypes": [
          "owner_list",
          "division_order",
          "pay_deck"
        ]
      },
      "whatSatisfies": "A count of working-interest and royalty owners, or the owner deck it can be counted from.",
      "kind": "request",
      "owner": "Accounting",
      "fields": [
        {
          "key": "wiOwners",
          "label": "WI owners",
          "type": "integer"
        },
        {
          "key": "royaltyOwners",
          "label": "Royalty owners",
          "type": "integer"
        }
      ],
      "feeds": [
        "PO-F-09",
        "PC-F-06",
        "PS-F-03",
        "PS-F-04"
      ],
      "operatedOnly": true
    },
    {
      "id": "PO-F-07",
      "phase": "pre_offer",
      "category": "financial",
      "item": "# of royalty owners in suspense (reason) and $ held in suspense",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-F-07",
        "text": "doc type suspense_report; $ + count entered on override",
        "docTypes": [
          "suspense_report"
        ]
      },
      "whatSatisfies": "The suspense report: owners in suspense, the reason for each, and the dollars held.",
      "kind": "request",
      "owner": "Accounting",
      "fields": [
        {
          "key": "ownersInSuspense",
          "label": "Owners in suspense",
          "type": "integer"
        },
        {
          "key": "suspenseUsd",
          "label": "$ held in suspense",
          "type": "currency"
        },
        {
          "key": "reason",
          "label": "Main reason",
          "type": "select",
          "options": [
            "Unknown address",
            "Title dispute",
            "Unsigned division order",
            "Deceased owner",
            "Minimum pay",
            "Other"
          ]
        }
      ],
      "feeds": [
        "PC-F-04",
        "PC-F-05"
      ],
      "operatedOnly": true
    },
    {
      "id": "PO-F-08",
      "phase": "pre_offer",
      "category": "financial",
      "item": "Crude purchase and gas gathering contracts (MVCs, processing, transportation)",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-F-08",
        "text": "doc type purchase_contract|gathering|transport + assignability register; Partial while any contract Open",
        "docTypes": [
          "purchase_contract",
          "gathering",
          "transport"
        ]
      },
      "whatSatisfies": "Crude purchase, gas gathering, processing and transportation contracts. Flag any minimum volume commitment.",
      "kind": "request",
      "owner": "Accounting"
    },
    {
      "id": "PO-F-09",
      "phase": "pre_offer",
      "category": "financial",
      "item": "Division orders and decimal interest chart",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-F-09",
        "text": "doc type division_order|decimal_interest",
        "docTypes": [
          "division_order",
          "decimal_interest"
        ]
      },
      "whatSatisfies": "Division orders and the decimal interest chart for each well.",
      "kind": "request",
      "owner": "Accounting",
      "feeds": [
        "PC-F-06"
      ],
      "operatedOnly": true
    },
    {
      "id": "PO-O-01",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Pull all P-4s & P-5s",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-O-01",
        "text": "doc type rrc_p4|rrc_p5 or well-file tag rrc; Partial = share of wells with rrc tag",
        "docTypes": [
          "rrc_p4",
          "rrc_p5"
        ]
      },
      "labels": {
        "TX": "Pull all P-4s & P-5s",
        "KS": "Pull KCC operator licenses and T-1 transfer forms",
        "OK": "Pull OCC Form 1073 operator records and surety",
        "CO": "Pull ECMC Form 10 operator registrations",
        "NM": "Pull OCD C-145 operator change and bond records",
        "NE": "Pull NOGCC operator registrations",
        "KY": "Pull KY DOG operator registrations and transfer forms",
        "default": "Pull operator-of-record and transfer forms from the regulator"
      },
      "whatSatisfies": "The operator-of-record filing and the seller's organization report for every well.",
      "kind": "request",
      "owner": "Operations",
      "feeds": [
        "PC-O-04"
      ],
      "operatedOnly": true
    },
    {
      "id": "PO-O-02",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Last two years of production history",
      "method": "auto",
      "requiredForPhase": true,
      "rule": {
        "type": "auto",
        "check": "PO-O-02",
        "text": "monthly production on the wells, or a production-history file: share of PDP wells with >=24 mo"
      },
      "whatSatisfies": "Monthly oil, gas and water production by well for the last 24 months.",
      "kind": "request",
      "owner": "Engineering"
    },
    {
      "id": "PO-O-03",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Last two years of first purchaser statements (oil and gas)",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-O-03",
        "text": "doc type purchaser_statement|check_stub|remittance",
        "docTypes": [
          "purchaser_statement"
        ]
      },
      "whatSatisfies": "First purchaser statements or check stubs for oil and gas, last 24 months.",
      "kind": "request",
      "owner": "Operations"
    },
    {
      "id": "PO-O-04",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Last two years of workovers, pulling, acid jobs, out-of-scope ops by well",
      "method": "doc",
      "requiredForPhase": false,
      "rule": {
        "type": "doc",
        "check": "PO-O-04",
        "text": "well-file tag ops + doc type workover; LOS workover lines",
        "docTypes": [
          "workover"
        ]
      },
      "whatSatisfies": "Workover, pulling, acid and other out-of-scope jobs by well for the last 24 months, with cost.",
      "kind": "request",
      "owner": "Operations"
    },
    {
      "id": "PO-O-05",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Recent down time reports",
      "method": "doc",
      "requiredForPhase": false,
      "rule": {
        "type": "doc",
        "check": "PO-O-05",
        "text": "doc type downtime",
        "docTypes": [
          "downtime"
        ]
      },
      "whatSatisfies": "Recent downtime reports by well with the cause.",
      "kind": "request",
      "owner": "Operations"
    },
    {
      "id": "PO-O-06",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Environmental issues",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-O-06",
        "text": "doc type environmental|phase_i|spill; override for 'none known'",
        "docTypes": [
          "environmental"
        ]
      },
      "whatSatisfies": "Any known spills, releases, NORM, pits or open environmental items. Evidence found here needs review, not a green check.",
      "kind": "disclosure",
      "owner": "Operations",
      "feeds": [
        "PC-O-02",
        "PS-O-06"
      ]
    },
    {
      "id": "PO-O-07",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Well treatment program (condensate, chemical)",
      "method": "doc",
      "requiredForPhase": false,
      "rule": {
        "type": "doc",
        "check": "PO-O-07",
        "text": "doc type chemical|treatment",
        "docTypes": [
          "chemical"
        ]
      },
      "whatSatisfies": "The chemical and treatment program by well, including condensate treatment.",
      "kind": "request",
      "owner": "Operations"
    },
    {
      "id": "PO-O-08",
      "phase": "pre_offer",
      "category": "operations",
      "item": "List of all active and inactive wells",
      "method": "auto",
      "requiredForPhase": true,
      "rule": {
        "type": "auto",
        "check": "PO-O-08",
        "text": "deal-package wells/masterWells with status + statusCounts"
      },
      "whatSatisfies": "A list of every well, active and inactive, with API number and status.",
      "kind": "request",
      "owner": "Operations",
      "feeds": [
        "PC-O-04",
        "PS-O-01"
      ]
    },
    {
      "id": "PO-O-09",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Equipment list and condition (tanks, sizes), owned or leased",
      "method": "doc",
      "requiredForPhase": false,
      "rule": {
        "type": "doc",
        "check": "PO-O-09",
        "text": "doc type equipment_inventory; register rows mentioning leased compressors -> Partial",
        "docTypes": [
          "equipment_inventory"
        ]
      },
      "whatSatisfies": "Equipment list by lease with condition, tank count and size, and whether each item is owned or leased.",
      "kind": "request",
      "owner": "Operations",
      "fields": [
        {
          "key": "tankCount",
          "label": "Tanks",
          "type": "integer"
        },
        {
          "key": "tankSizeBbl",
          "label": "Tank size (bbl)",
          "type": "integer"
        },
        {
          "key": "ownership",
          "label": "Owned or leased",
          "type": "select",
          "options": [
            "Owned",
            "Leased",
            "Mixed"
          ]
        }
      ]
    },
    {
      "id": "PO-O-10",
      "phase": "pre_offer",
      "category": "operations",
      "item": "SWDs (owned or third party)",
      "method": "doc",
      "requiredForPhase": false,
      "rule": {
        "type": "doc",
        "check": "PO-O-10",
        "text": "doc type swd|disposal; or well type SWD in well list",
        "docTypes": [
          "swd"
        ]
      },
      "whatSatisfies": "Saltwater disposal wells used, owned or third party, with the disposal agreement if third party.",
      "kind": "request",
      "owner": "Operations"
    },
    {
      "id": "PO-O-11",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Ensure regulatory compliance",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PO-O-11",
        "text": "Attestation; hints from P-5 status + compliance-order docs"
      },
      "whatSatisfies": "A sign-off that the wells are in regulatory compliance, with any open violations or compliance orders listed.",
      "kind": "signoff",
      "owner": "Operations"
    },
    {
      "id": "PO-O-12",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Any G&G info",
      "method": "auto",
      "requiredForPhase": false,
      "rule": {
        "type": "auto",
        "check": "PO-O-12",
        "text": "log-evidence index / LAS flags / geoscience, or doc type well_log|drilling_prognosis",
        "docTypes": ["well_log", "drilling_prognosis"]
      },
      "whatSatisfies": "Well logs, LAS files and any other G&G data on hand.",
      "kind": "request",
      "owner": "Engineering"
    },
    {
      "id": "PO-O-13",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Inactive vs active well lists with plugging deadlines and 14(b)(2) extensions",
      "method": "auto",
      "requiredForPhase": true,
      "rule": {
        "type": "auto",
        "check": "PO-O-13",
        "text": "inactive wells from status (A) + doc type rrc_14b2|plugging_extension for deadlines",
        "docTypes": [
          "rrc_14b2",
          "plugging_extension"
        ]
      },
      "labels": {
        "TX": "Inactive vs active well lists with plugging deadlines and 14(b)(2) extensions",
        "KS": "Inactive vs active well lists with plugging deadlines and KCC temporary abandonment approvals",
        "OK": "Inactive vs active well lists with plugging deadlines and OCC temporary abandonment status",
        "default": "Inactive vs active well lists with plugging deadlines and extensions"
      },
      "whatSatisfies": "Inactive wells with plugging deadlines and any extensions granted.",
      "kind": "request",
      "owner": "Operations",
      "fields": [
        {
          "key": "inactiveWells",
          "label": "Inactive wells",
          "type": "integer"
        },
        {
          "key": "earliestPlugDeadline",
          "label": "Earliest plugging deadline",
          "type": "date"
        }
      ]
    },
    {
      "id": "PO-O-14",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Recent capex projects with results",
      "method": "auto",
      "requiredForPhase": false,
      "rule": {
        "type": "auto",
        "check": "PO-O-14",
        "text": "wells[].capexM / PBP cases + doc type afe|capex",
        "docTypes": [
          "afe",
          "capex"
        ]
      },
      "whatSatisfies": "Recent capital projects with the AFEs and the results.",
      "kind": "request",
      "owner": "Engineering"
    },
    {
      "id": "PO-O-15",
      "phase": "pre_offer",
      "category": "operations",
      "item": "Condition of well files",
      "method": "auto",
      "requiredForPhase": false,
      "rule": {
        "type": "auto",
        "check": "PO-O-15",
        "text": "well-file-index coverage: wells with files / total wells; daily drilling and flowback reports count as evidence",
        "docTypes": ["daily_drilling_report", "flowback_report"]
      },
      "whatSatisfies": "A grade on the state of the well files: good, fair or poor.",
      "kind": "request",
      "owner": "Operations",
      "fields": [
        {
          "key": "grade",
          "label": "Well files",
          "type": "select",
          "options": [
            "Good",
            "Fair",
            "Poor"
          ]
        }
      ]
    },
    {
      "id": "PO-L-01",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Copies of all leases (amendments, ratifications, extensions)",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-L-01",
        "text": "doc type lease|amendment|ratification|extension (deduped checklist line)",
        "docTypes": [
          "lease",
          "amendment",
          "ratification",
          "extension"
        ]
      },
      "whatSatisfies": "Copies of every lease with amendments, ratifications and extensions.",
      "kind": "request",
      "owner": "Land",
      "feeds": [
        "PC-L-03"
      ]
    },
    {
      "id": "PO-L-02",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Lease status: HBP, primary term expirations, drilling obligations, depth restrictions, SI royalty",
      "method": "auto",
      "requiredForPhase": true,
      "rule": {
        "type": "auto",
        "check": "PO-L-02",
        "text": "acreageUnits HBP/Non-HBP + lease-status.geojson -> Partial; Complete needs lease-term schedule doc",
        "docTypes": [
          "lease_term_schedule"
        ]
      },
      "whatSatisfies": "Lease status for each lease: HBP or primary term, expiration dates, drilling obligations, depth restrictions and shut-in royalty terms.",
      "kind": "request",
      "owner": "Land"
    },
    {
      "id": "PO-L-03",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Latest title opinions",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-L-03",
        "text": "doc type title_opinion (DOTO|title opinion)",
        "docTypes": [
          "title_opinion"
        ]
      },
      "whatSatisfies": "The latest title opinions, division order title opinions included.",
      "kind": "request",
      "owner": "Legal",
      "feeds": [
        "PC-L-01"
      ]
    },
    {
      "id": "PO-L-04",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Royalty clauses on post-production cost deductions",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-L-04",
        "text": "lease docs present + override note; LOS gasDeducts shown as context",
        "docTypes": [
          "lease"
        ]
      },
      "whatSatisfies": "The royalty clause in each lease on post-production cost deductions, reviewed and summarized.",
      "kind": "request",
      "owner": "Legal"
    },
    {
      "id": "PO-L-05",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Joint Operating Agreements with COPAS provisions",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-L-05",
        "text": "doc type joa|copas",
        "docTypes": [
          "joa",
          "copas"
        ]
      },
      "whatSatisfies": "Joint operating agreements with the COPAS accounting procedure attached.",
      "kind": "request",
      "owner": "Land"
    },
    {
      "id": "PO-L-06",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Reserve report (if available)",
      "method": "auto",
      "requiredForPhase": false,
      "rule": {
        "type": "auto",
        "check": "PO-L-06",
        "text": "cases[] caseSource sellerReserveReport/aries or doc type reserve_report",
        "docTypes": [
          "reserve_report"
        ]
      },
      "whatSatisfies": "The seller's reserve report, if one exists.",
      "kind": "request",
      "owner": "Engineering"
    },
    {
      "id": "PO-L-07",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Decline curves / seller forecast case",
      "method": "auto",
      "requiredForPhase": true,
      "rule": {
        "type": "auto",
        "check": "PO-L-07",
        "text": "Seller forecast case on file: ingested forecast, a seller-forecast document, or a live seller-database row"
      },
      "whatSatisfies": "The seller's forecast case: decline curves in the file the seller sent.",
      "kind": "request",
      "owner": "Engineering"
    },
    {
      "id": "PO-L-08",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Current drilling plans (permitted and unpermitted)",
      "method": "doc",
      "requiredForPhase": false,
      "rule": {
        "type": "doc",
        "check": "PO-L-08",
        "text": "PUD/PBP cases (A partial) + doc type drilling_plan|permit",
        "docTypes": [
          "drilling_plan"
        ]
      },
      "whatSatisfies": "Current drilling plans, permitted and unpermitted, with locations and timing.",
      "kind": "request",
      "owner": "Land"
    },
    {
      "id": "PO-L-09",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Seismic data",
      "method": "doc",
      "requiredForPhase": false,
      "rule": {
        "type": "doc",
        "check": "PO-L-09",
        "text": "doc type seismic",
        "docTypes": [
          "seismic"
        ]
      },
      "whatSatisfies": "Seismic data and licenses covering the acreage.",
      "kind": "request",
      "owner": "Engineering"
    },
    {
      "id": "PO-L-10",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Preferential purchase rights and consent to assign agreements",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-L-10",
        "text": "doc type ppr|consent + assignability register Open -> Partial",
        "docTypes": [
          "ppr",
          "consent"
        ]
      },
      "whatSatisfies": "Preferential purchase rights and consent-to-assign provisions in each lease, JOA and contract, with the notice periods.",
      "kind": "request",
      "owner": "Legal",
      "feeds": [
        "PC-L-01"
      ]
    },
    {
      "id": "PO-L-11",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Surface use agreements, rights-of-way, easements",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PO-L-11",
        "text": "doc type sua|row|easement",
        "docTypes": [
          "sua",
          "row",
          "easement"
        ]
      },
      "whatSatisfies": "Surface use agreements, rights-of-way and easements for roads, pipelines and facilities.",
      "kind": "request",
      "owner": "Land"
    },
    {
      "id": "PO-L-12",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Lease WI and NRI",
      "method": "auto",
      "requiredForPhase": true,
      "rule": {
        "type": "auto",
        "check": "PO-L-12",
        "text": "every modeled well has wi and nri"
      },
      "whatSatisfies": "Working interest and net revenue interest for every lease and well.",
      "kind": "request",
      "owner": "Land"
    },
    {
      "id": "PO-L-13",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Schedule of all burdens: royalties, ORRI, NPI, production payments",
      "method": "auto",
      "requiredForPhase": true,
      "rule": {
        "type": "auto",
        "check": "PO-L-13",
        "text": "implied burden (WI-NRI) per well = Partial; itemized schedule doc type burden_schedule = Complete",
        "docTypes": [
          "burden_schedule"
        ]
      },
      "whatSatisfies": "A schedule of every burden: lease royalty, overriding royalty, net profits interest and production payments.",
      "kind": "request",
      "owner": "Land"
    },
    {
      "id": "PO-L-14",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Maps",
      "method": "auto",
      "requiredForPhase": false,
      "rule": {
        "type": "auto",
        "check": "PO-L-14",
        "text": "well locations + land shapefiles/geojson, or doc type plat",
        "docTypes": ["plat"]
      },
      "whatSatisfies": "Lease, unit and well maps, as shapefiles or GeoJSON where possible.",
      "kind": "request",
      "owner": "Land"
    },
    {
      "id": "PO-L-15",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Other agreements (unitization, pooling, farmouts, AMI)",
      "method": "doc",
      "requiredForPhase": false,
      "rule": {
        "type": "doc",
        "check": "PO-L-15",
        "text": "doc type unit|pooling|farmout|ami; unit names in acreageUnits -> Partial",
        "docTypes": [
          "unit",
          "pooling",
          "farmout",
          "ami"
        ]
      },
      "whatSatisfies": "Unitization, pooling, farmout and area-of-mutual-interest agreements affecting the assets.",
      "kind": "request",
      "owner": "Land"
    },
    {
      "id": "PO-L-16",
      "phase": "pre_offer",
      "category": "land_legal",
      "item": "Known legal issues (liens, title defects, compliance orders)",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PO-L-16",
        "text": "Attestation + lien/defect docs",
        "docTypes": [
          "lien"
        ]
      },
      "whatSatisfies": "Known liens, title defects and compliance orders, listed. Evidence found here needs review, not a green check.",
      "kind": "disclosure",
      "owner": "Legal"
    },
    {
      "id": "PC-F-01",
      "phase": "pre_closing",
      "category": "financial",
      "item": "Proper accounting for applicable adjustments",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PC-F-01",
        "text": "Attestation; context: effective date + interim NOCF"
      },
      "whatSatisfies": "The preliminary settlement statement with adjustments from the effective date to closing.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "closing",
        "offsetDays": -3
      },
      "feeds": [
        "PS-F-01"
      ]
    },
    {
      "id": "PC-F-02",
      "phase": "pre_closing",
      "category": "financial",
      "item": "Wiring instructions from Seller",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PC-F-02",
        "text": "Attestation only - never store bank details"
      },
      "whatSatisfies": "Confirmation that wiring instructions were received from the seller and verified by phone. Never record the details here.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "closing",
        "offsetDays": -3
      }
    },
    {
      "id": "PC-F-03",
      "phase": "pre_closing",
      "category": "financial",
      "item": "Last electric statement from Seller ({electricProvider})",
      "method": "doc",
      "requiredForPhase": false,
      "rule": {
        "type": "doc",
        "check": "PC-F-03",
        "text": "doc type electric_statement",
        "docTypes": [
          "electric_statement"
        ]
      },
      "whatSatisfies": "The seller's last electric statement for each lease so the accounts can be moved.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "closing",
        "offsetDays": -5
      },
      "feeds": [
        "PS-O-04"
      ],
      "operatedOnly": true
    },
    {
      "id": "PC-F-04",
      "phase": "pre_closing",
      "category": "financial",
      "item": "Monies that need to be escheated to the state",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PC-F-04",
        "text": "suspense report (PO-F-07) + escheat doc",
        "docTypes": [
          "suspense_report",
          "escheat"
        ]
      },
      "whatSatisfies": "Suspense funds that must be escheated to the state, identified and reconciled.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "closing",
        "offsetDays": -10
      },
      "fields": [
        {
          "key": "escheatUsd",
          "label": "$ to escheat",
          "type": "currency"
        }
      ]
    },
    {
      "id": "PC-F-05",
      "phase": "pre_closing",
      "category": "financial",
      "item": "Seller flushes all owners in minimum pay status",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PC-F-05",
        "text": "Attestation"
      },
      "whatSatisfies": "Confirmation that the seller will pay out every owner held in minimum-pay status.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "closing",
        "offsetDays": -5
      },
      "operatedOnly": true
    },
    {
      "id": "PC-F-06",
      "phase": "pre_closing",
      "category": "financial",
      "item": "Conversion of pay decks from seller",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PC-F-06",
        "text": "doc type pay_deck",
        "docTypes": [
          "pay_deck"
        ]
      },
      "whatSatisfies": "The seller's pay decks converted into the buyer's accounting system.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "closing",
        "offsetDays": -10
      },
      "operatedOnly": true
    },
    {
      "id": "PC-F-07",
      "phase": "pre_closing",
      "category": "financial",
      "item": "P-5 financial assurance in place",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PC-F-07",
        "text": "Attestation (P-5 / financial assurance)"
      },
      "labels": {
        "TX": "P-5 financial assurance in place",
        "default": "Bonding and financial assurance in place"
      },
      "whatSatisfies": "Operator bond or financial assurance filed with the regulator.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "closing",
        "offsetDays": -30
      },
      "operatedOnly": true
    },
    {
      "id": "PC-O-01",
      "phase": "pre_closing",
      "category": "operations",
      "item": "Gauging of all tank batteries",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PC-O-01",
        "text": "Attestation"
      },
      "whatSatisfies": "Tank battery gauges for every lease, dated and signed.",
      "kind": "task",
      "owner": "Operations",
      "due": {
        "anchor": "closing",
        "offsetDays": -1
      },
      "fields": [
        {
          "key": "gaugeDate",
          "label": "Gauge date",
          "type": "date"
        }
      ],
      "feeds": [
        "PS-O-03"
      ],
      "operatedOnly": true
    },
    {
      "id": "PC-O-02",
      "phase": "pre_closing",
      "category": "operations",
      "item": "Final environmental inspection of all wells",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PC-O-02",
        "text": "Attestation (+ inspection report doc)"
      },
      "whatSatisfies": "A final environmental inspection of every well, with the report.",
      "kind": "task",
      "owner": "Operations",
      "due": {
        "anchor": "closing",
        "offsetDays": -7
      }
    },
    {
      "id": "PC-O-03",
      "phase": "pre_closing",
      "category": "operations",
      "item": "Hiring of all pumpers",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PC-O-03",
        "text": "Attestation"
      },
      "whatSatisfies": "Pumpers hired or contracted for every route.",
      "kind": "task",
      "owner": "Operations",
      "due": {
        "anchor": "closing",
        "offsetDays": -14
      },
      "operatedOnly": true
    },
    {
      "id": "PC-O-04",
      "phase": "pre_closing",
      "category": "operations",
      "item": "Prepare P-4 change forms for closing",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PC-O-04",
        "text": "Attestation; well count from well list as context"
      },
      "labels": {
        "TX": "Prepare P-4 change forms for closing",
        "KS": "Prepare KCC T-1 transfer forms for closing",
        "OK": "Prepare OCC Form 1073 for closing",
        "CO": "Prepare ECMC Form 10 for closing",
        "NM": "Prepare OCD C-145 for closing",
        "default": "Prepare operator change forms for closing"
      },
      "whatSatisfies": "Operator change forms prepared for every well, ready to file at closing.",
      "kind": "task",
      "owner": "Operations",
      "due": {
        "anchor": "closing",
        "offsetDays": -5
      },
      "feeds": [
        "PS-O-01"
      ],
      "operatedOnly": true
    },
    {
      "id": "PC-L-01",
      "phase": "pre_closing",
      "category": "land_legal",
      "item": "Comfortable with title",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PC-L-01",
        "text": "Attestation; warns if PO-L-03 title opinions Missing"
      },
      "whatSatisfies": "A sign-off from land or counsel that title is acceptable, with any defects waived or cured.",
      "kind": "signoff",
      "owner": "Legal",
      "due": {
        "anchor": "closing",
        "offsetDays": -7
      }
    },
    {
      "id": "PC-L-02",
      "phase": "pre_closing",
      "category": "land_legal",
      "item": "3 copies of the PSA",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PC-L-02",
        "text": "doc type psa present + copies attested",
        "docTypes": [
          "psa"
        ]
      },
      "whatSatisfies": "Three executed copies of the purchase and sale agreement.",
      "kind": "task",
      "owner": "Legal",
      "due": {
        "anchor": "closing",
        "offsetDays": -2
      },
      "feeds": [
        "PS-L-02"
      ]
    },
    {
      "id": "PC-L-03",
      "phase": "pre_closing",
      "category": "land_legal",
      "item": "3 copies of Assignments and Bill of Sale per county",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PC-L-03",
        "text": "doc type assignment_bos per county; required counties = distinct well counties",
        "docTypes": [
          "assignment_bos"
        ]
      },
      "whatSatisfies": "Three executed copies of the assignment and bill of sale for each county where the leases sit.",
      "kind": "task",
      "owner": "Legal",
      "due": {
        "anchor": "closing",
        "offsetDays": -2
      },
      "feeds": [
        "PS-L-01"
      ]
    },
    {
      "id": "PS-F-01",
      "phase": "post_closing",
      "category": "financial",
      "item": "Proper accounting for applicable adjustments (final settlement)",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PS-F-01",
        "text": "Attestation"
      },
      "whatSatisfies": "The final settlement statement, usually 90 to 180 days after closing, agreed and paid.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "closing",
        "offsetDays": 90
      }
    },
    {
      "id": "PS-F-02",
      "phase": "post_closing",
      "category": "financial",
      "item": "Seller's PR report and Comptroller report as of effective date",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PS-F-02",
        "text": "doc type production_report|comptroller",
        "docTypes": [
          "production_report",
          "comptroller"
        ]
      },
      "labels": {
        "TX": "Seller's PR report and Comptroller report as of effective date",
        "default": "Seller's production report and severance tax report as of effective date"
      },
      "whatSatisfies": "The seller's production report and severance tax report as of the effective date.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "effective",
        "offsetDays": 30
      }
    },
    {
      "id": "PS-F-03",
      "phase": "post_closing",
      "category": "financial",
      "item": "Transfer of all owners to {backOffice}",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PS-F-03",
        "text": "Attestation"
      },
      "whatSatisfies": "Every owner set up in {backOffice} with decks and addresses.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "closing",
        "offsetDays": 30
      },
      "operatedOnly": true
    },
    {
      "id": "PS-F-04",
      "phase": "post_closing",
      "category": "financial",
      "item": "Send out new division orders",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PS-F-04",
        "text": "Attestation"
      },
      "whatSatisfies": "New division orders sent to every owner.",
      "kind": "task",
      "owner": "Accounting",
      "due": {
        "anchor": "closing",
        "offsetDays": 45
      },
      "operatedOnly": true
    },
    {
      "id": "PS-O-01",
      "phase": "post_closing",
      "category": "operations",
      "item": "File all P-4s with the RRC",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PS-O-01",
        "text": "Attestation (+ filed P-4 doc)",
        "docTypes": [
          "rrc_p4"
        ]
      },
      "labels": {
        "TX": "File all P-4s with the RRC",
        "KS": "File T-1s with the KCC",
        "OK": "File Form 1073 with the OCC",
        "CO": "File Form 10 with the ECMC",
        "NM": "File C-145 with the OCD",
        "NE": "File operator transfers with the NOGCC",
        "default": "File operator change forms with the regulator"
      },
      "whatSatisfies": "Operator change forms filed with the regulator and approved.",
      "kind": "task",
      "owner": "Operations",
      "due": {
        "anchor": "closing",
        "offsetDays": 5
      },
      "operatedOnly": true
    },
    {
      "id": "PS-O-02",
      "phase": "post_closing",
      "category": "operations",
      "item": "Notify all first purchasers of operator change",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PS-O-02",
        "text": "Attestation; purchaser list from PO-F-04 as context"
      },
      "whatSatisfies": "Every first purchaser notified of the operator change, with new remittance details.",
      "kind": "task",
      "owner": "Operations",
      "due": {
        "anchor": "closing",
        "offsetDays": 3
      }
    },
    {
      "id": "PS-O-03",
      "phase": "post_closing",
      "category": "operations",
      "item": "Effective-date tank strapping (pre- vs post-effective oil ownership)",
      "method": "doc",
      "requiredForPhase": true,
      "rule": {
        "type": "doc",
        "check": "PS-O-03",
        "text": "doc type strapping|tank_gauge from Seller",
        "docTypes": [
          "strapping"
        ]
      },
      "whatSatisfies": "Tank fluid levels (strapping) at the effective date from the seller, so oil in tanks is split correctly.",
      "kind": "task",
      "owner": "Operations",
      "due": {
        "anchor": "closing",
        "offsetDays": 5
      },
      "fields": [
        {
          "key": "oilInTanksBbl",
          "label": "Oil in tanks at effective date (bbl)",
          "type": "integer"
        }
      ]
    },
    {
      "id": "PS-O-04",
      "phase": "post_closing",
      "category": "operations",
      "item": "Notify electrical providers of ownership change",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PS-O-04",
        "text": "Attestation"
      },
      "whatSatisfies": "Electric providers notified and the accounts moved to the buyer.",
      "kind": "task",
      "owner": "Operations",
      "due": {
        "anchor": "closing",
        "offsetDays": 3
      },
      "operatedOnly": true
    },
    {
      "id": "PS-O-05",
      "phase": "post_closing",
      "category": "operations",
      "item": "New signs on leases",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PS-O-05",
        "text": "Attestation"
      },
      "whatSatisfies": "New lease signs posted with the operator name, lease name and emergency number.",
      "kind": "task",
      "owner": "Operations",
      "due": {
        "anchor": "closing",
        "offsetDays": 30
      },
      "operatedOnly": true
    },
    {
      "id": "PS-O-06",
      "phase": "post_closing",
      "category": "operations",
      "item": "All environmental updates ({environmentalConsultant})",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PS-O-06",
        "text": "Attestation"
      },
      "whatSatisfies": "Environmental records updated with {environmentalConsultant}.",
      "kind": "task",
      "owner": "Operations",
      "due": {
        "anchor": "closing",
        "offsetDays": 30
      }
    },
    {
      "id": "PS-L-01",
      "phase": "post_closing",
      "category": "land_legal",
      "item": "File the Assignment and Bill of Sale in all applicable counties",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PS-L-01",
        "text": "Attestation per county (county list auto)"
      },
      "whatSatisfies": "Assignment and bill of sale recorded in every applicable county.",
      "kind": "task",
      "owner": "Legal",
      "due": {
        "anchor": "closing",
        "offsetDays": 5
      }
    },
    {
      "id": "PS-L-02",
      "phase": "post_closing",
      "category": "land_legal",
      "item": "Send a copy of the executed PSA to {closingCounsel}",
      "method": "manual",
      "requiredForPhase": true,
      "rule": {
        "type": "manual",
        "check": "PS-L-02",
        "text": "Attestation"
      },
      "whatSatisfies": "A copy of the executed PSA sent to {closingCounsel}.",
      "kind": "task",
      "owner": "Legal",
      "due": {
        "anchor": "closing",
        "offsetDays": 5
      }
    }
  ],
  "computedStatuses": [
    "Upcoming"
  ],
  "owners": [
    "Accounting",
    "Operations",
    "Land",
    "Legal",
    "Engineering"
  ],
  "kinds": {
    "request": "Pre-offer data request to the seller. Complete, Partial, Missing.",
    "disclosure": "Risk disclosure. Evidence found turns the row amber for review; only an attestation completes it.",
    "signoff": "A named person attests. Nothing is computed.",
    "task": "Buyer task keyed to the closing or effective date. Shows Upcoming until its phase, then a due date."
  },
  "buyerProfileTokens": [
    "backOffice",
    "closingCounsel",
    "environmentalConsultant",
    "electricProvider"
  ]
}
